import React, { useState, useEffect } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { chevronLeft, plus } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'
import ReactQuill from "react-quill";

const Create = () => {
    const [error, setError] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [uploading, setUploading] = useState({});
    const [uploadingCount, setUploadingCount] = useState(0);
    // const [link, setLink] = useState(null)

    const [sections, setSections] = useState([
        {
            title: '',
            description: '',
            image: '',
            preview: '',
            uploading: false
        }
    ]);

    const [faq, setFaq] = useState([
        {
            question: '',
            answer: ''
        }
    ])

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        formState: { errors }
    } = useForm()

    const navigate = useNavigate()

    const [header] = useState({
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    })

    // Main Image
    const handleImage = event => {
        const file = event.target.files[0]

        if (file) {
            // const size = parseInt(file.size) / 1000

            // if (size > 500) {
            //     setError({
            //         ...error,
            //         image: 'Select less than 500KB file.'
            //     })
            //     return
            // }

            setSelectedFile({
                image: file,
                preview: URL.createObjectURL(file)
            })
        }
    }

    // Upload Image
    const UploadImage = async (event) => {
    try {
        const file = event.target.files[0];

        if (!file) return null;

        // const size = file.size / 1024;

        // if (size > 500) {
        //     setError(prev => ({
        //         ...prev,
        //         image: 'Select less than 500KB file.'
        //     }));

        //     return null;
        // }

        const formData = new FormData();

        formData.append('image', file);

        const image = await Requests.Blog.StoreImage(
            formData,
            header
        );

        return image;

    } catch (error) {
        console.log(error);
        return null;
    }
};

    // Sections
    // const addSection = () => {
    //     setSections([
    //         ...sections,
    //         {
    //             title: '',
    //             description: '',
    //             image: ''
    //         }
    //     ])
    // }
    // Sections
const addSection = () => {
    setSections([
        ...sections,
        {
            title: '',
            description: '',
            image: '',
            preview: '',
            uploading: false
        }
    ]);
};

    const removeSection = index => {
        const data = [...sections]
        data.splice(index, 1)
        setSections(data)
    }

    const handleSectionChange = (index, field, value) => {
        const data = [...sections]
        data[index][field] = value
        setSections(data)
    }

    // FAQ
    const addFaq = () => {
        setFaq([
            ...faq,
            {
                question: '',
                answer: ''
            }
        ])
    }

    const removeFaq = index => {
        const data = [...faq]
        data.splice(index, 1)
        setFaq(data)
    }

    const handleFaqChange = (index, field, value) => {
        const data = [...faq]
        data[index][field] = value
        setFaq(data)
    }
const title = watch("title");
const generateSlug = (value) => {
  return value
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // Remove special characters
    .replace(/\s+/g, "-")     // Space to hyphen
    .replace(/-+/g, "-");     // Remove duplicate hyphens
};

useEffect(() => {
  setValue("link", generateSlug(title || ""));
}, [title, setValue]);

    // // Submit
    // const onSubmit = async data => {
    //     // console.log('Form Data:', data);
    //     try {
    //         if (!selectedFile) {
    //             return setError({
    //                 ...error,
    //                 image: 'Image is required'
    //             })
    //         }

    //         setLoading(true)

    //         const formData = new FormData()

    //         formData.append('title', data.title)
    //         formData.append('link', data.link)
    //         formData.append('description', data.description)
    //         formData.append('metaTitle', data.metaTitle)
    //         formData.append('metaDescription', data.metaDescription)

    //         formData.append(
    //             'sections',
    //             JSON.stringify(sections)
    //         )

    //         formData.append(
    //             'faq',
    //             JSON.stringify(faq)
    //         )

    //         formData.append(
    //             'image',
    //             selectedFile.image
    //         )

    //         const response = await Requests.Blog.Store(
    //             formData,
    //             header
    //         )

    //         if (response) {
    //             navigate('/dashboard/website/blog')
    //         }
    //     } catch (error) {
    //         console.log(error)
    //     } finally {
    //         setLoading(false)
    //     }
    // }

    const onSubmit = async (data) => {
    // Wait until all images are uploaded
    if (uploadingCount > 0) {
        setError({
            ...error,
            image: "Please wait! Images are still uploading."
        });
        return;
    }

    try {
        if (!selectedFile) {
            return setError({
                ...error,
                image: "Image is required"
            });
        }

        setLoading(true);

        const formData = new FormData();

        formData.append("title", data.title);
        formData.append("link", data.link);
        formData.append("description", data.description);
        formData.append("metaTitle", data.metaTitle);
        formData.append("metaDescription", data.metaDescription);

        formData.append(
            "sections",
            JSON.stringify(sections)
        );

        formData.append(
            "faq",
            JSON.stringify(faq)
        );

        formData.append(
            "image",
            selectedFile.image
        );

        const response = await Requests.Blog.Store(
            formData,
            header
        );

        if (response) {
            navigate("/dashboard/website/blog");
        }

    } catch (error) {
        console.log(error);
    } finally {
        setLoading(false);
    }
};

    return (
        <div className="store-blog pb-4">
            <div className="container-fluid">

                <div className="card border-0 shadow-sm">

                    <div className="card-header p-3 p-lg-4 bg-white">
                        <div className="d-flex justify-content-between">

                            <h6 className="mb-0">
                                Store Blog
                            </h6>

                            <Link
                                to="/dashboard/website/blog"
                                className="btn shadow-none rounded-circle"
                            >
                                <Icon
                                    icon={chevronLeft}
                                    size={22}
                                />
                            </Link>

                        </div>
                    </div>

                    <div className="card-body p-4">

                        <form onSubmit={handleSubmit(onSubmit)}>

                            <div className="row">
                                 {/* Image */}

                            <div className="form-group mb-4">

                                {error?.image ? (
                                    <p className="text-danger">
                                        {error.image}
                                    </p>
                                ) : (
                                    <p>Image</p>
                                )}

                                <div className="d-flex">

                                    {selectedFile?.preview && (
                                        <div className="img-container mr-2">
                                            <div className="image border">
                                                <img
                                                    src={
                                                        selectedFile.preview
                                                    }
                                                    alt=""
                                                    className="img-fluid"
                                                />
                                            </div>
                                        </div>
                                    )}

                                    <div className="img-container">

                                        <div className="image border">

                                            <input
                                                type="file"
                                                className="upload"
                                                onChange={
                                                    handleImage
                                                }
                                            />

                                            <div className="flex-center flex-column">
                                                <Icon
                                                    icon={plus}
                                                    size={22}
                                                />
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                                <div className="col-lg-6">
                                    <div className="form-group mb-4">
                                        <p>Title</p>

                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Title"
                                            {...register('title', {
                                                required:
                                                    'Title is required'
                                            })}
                                        />

                                        {errors.title && (
                                            <small className="text-danger">
                                                {
                                                    errors.title
                                                        .message
                                                }
                                            </small>
                                        )}
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="form-group mb-4">
                                        <p>Link</p>

                                        <input
                                            type="text"
                                            // defaultValue={generateSlug(watch('title') || '')}
                                            className="form-control"
                                            placeholder="Link"
                                            {...register('link')}
                                        />
                                    </div>
                                </div>
                            </div>
                                            
                                {/* </div> */}

                                {/* <div className="col-lg-6">
                                    <div className="form-group mb-4">
                                        <p>Link</p>

                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Link"
                                            {...register('link')}
                                        />
                                    </div>
                                </div> */}

                            {/* </div> */}

                            <div className="form-group mb-4">
                                <p>Description</p>

                                <textarea
                                    rows={5}
                                    className="form-control"
                                    placeholder="Description"
                                    {...register(
                                        'description'
                                    )}
                                />
                            </div>

                            <div className="row">

                                <div className="col-lg-12">
                                    <div className="form-group mb-4">
                                        <p>Meta Title</p>

                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register(
                                                'metaTitle'
                                            )}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="form-group mb-4">
                                        <p>
                                            Meta Description
                                        </p>

                                        <textarea
                                            rows={3}
                                            className="form-control"
                                            {...register(
                                                'metaDescription'
                                            )}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-12">
                                    <div className="form-group mb-4">
                                        <p>
                                            Keywords
                                        </p>

                                        <textarea
                                            rows={3}
                                            className="form-control"
                                            {...register(
                                                'keywords'
                                            )}
                                        />
                                    </div>
                                </div>

                            </div>

                           

                            {/* Sections */}

                            <div className="mb-4">

                                <div className="d-flex justify-content-between mb-3">
                                    <h5>Sections</h5>

                                    
                                </div>

                                {sections.map(
                                    (item, index) => (
                                        <div
                                            key={index}
                                            className="border p-3 mb-3"
                                        >
                                        <div className="d-flex align-items-start gap-3 mb-3">

                                            <div className="img-container mb-3 text-start">
                                                <div className="image border">

                                                    <input
                                                        type="file"
                                                        className="upload"
                                                        onChange={async (e) => {
                                                            setUploading(prev => ({ ...prev, [index]: true }));
                                                            setUploadingCount(prev => prev + 1);

                                                            try {
                                                                const image = await UploadImage(e);

                                                                if (!image) return;

                                                                const data = [...sections];

                                                                data[index].image = image;
                                                                data[index].preview = URL.createObjectURL(e.target.files[0]);

                                                                setSections(data);
                                                            } finally {
                                                                setUploading(prev => ({ ...prev, [index]: false }));
                                                                setUploadingCount(prev => prev - 1);
                                                            }
                                                        }}
                                                        // onChange={async (e) => {
                                                        //     setUploading(prev => ({ ...prev, [index]: true }));
                                                        //     setUploadingCount(prev => prev + 1);

                                                        //     try {
                                                        //         const image = await UploadImage(e);

                                                        //         if (!image) return;

                                                        //         const data = [...sections];

                                                        //         data[index].image = image;
                                                        //         data[index].preview = URL.createObjectURL(e.target.files[0]);

                                                        //         setSections(data);
                                                        //     } finally {
                                                        //         setUploading(prev => ({ ...prev, [index]: false }));
                                                        //     }
                                                        // }}
                                                        // onChange={async (e) => {

                                                        //     const image = await UploadImage(e);

                                                        //     if (!image) return;

                                                        //     const data = [...sections];

                                                        //     data[index].image = image;
                                                        //     data[index].preview =
                                                        //         URL.createObjectURL(
                                                        //             e.target.files[0]
                                                        //         );

                                                        //     setSections(data);
                                                        // }}
                                                    />

                                                    <div className="flex-center flex-column">
                                                        <Icon
                                                            icon={plus}
                                                            size={22}
                                                        />
                                                    </div>

                                                </div>
                                            </div>

                                            {uploading[index] ? (
                                                <div
                                                    className="border rounded d-flex align-items-center justify-content-center"
                                                    style={{ width: 120, height: 120 }}
                                                >
                                                    Uploading...
                                                </div>
                                            ) : item.preview ? (
                                                <img
                                                    src={item.preview}
                                                    alt="Preview"
                                                    className="border rounded"
                                                    style={{
                                                        width: 120,
                                                        height: 120,
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            ) : null}

                                            {/* {item.uploading ? (
                                                    <div
                                                        className="border rounded d-flex align-items-center justify-content-center"
                                                        style={{ width: 120, height: 120 }}
                                                    >
                                                        Uploading...
                                                    </div>
                                                ) : item.preview ? (
                                                    <img
                                                        src={item.preview}
                                                        alt="Preview"
                                                        className="border rounded"
                                                        style={{
                                                            width: 120,
                                                            height: 120,
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                ) : null} */}

                                            {/* {item.preview && (
                                                <img
                                                    src={item.preview}
                                                    alt="Preview"
                                                    className="border rounded"
                                                    style={{
                                                        width: "120px",
                                                        height: "120px",
                                                        objectFit: "cover"
                                                    }}
                                                />
                                            )} */}

                                        </div>
                                        

                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder="Section Title"
                                                value={
                                                    item.title
                                                }
                                                onChange={e =>
                                                    handleSectionChange(
                                                        index,
                                                        'title',
                                                        e.target
                                                            .value
                                                    )
                                                }
                                            />
                                            <ReactQuill
                                                theme="snow"
                                                // style={{
                                                //     height: '150px'
                                                // }}
                                                className="mb-2"
                                                placeholder="Section Description"
                                                value={item.description}
                                                onChange={(value) =>
                                                    handleSectionChange(
                                                        index,
                                                        "description",
                                                        value
                                                    )
                                                }
                                            />

                                            <div className="mt-3">
                                                <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() =>
                                                    removeSection(
                                                        index
                                                    )
                                                }
                                            >
                                                Remove
                                            </button>
                                            </div>

                                            
                                        </div>
                                    )
                                )}
                                
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={
                                            addSection
                                        }
                                    >
                                        Add Section
                                    </button>
                                </div>
                            </div>

                            {/* FAQ */}

                            <div className="mb-4">

                                <div className="d-flex justify-content-between mb-3">
                                    <h5>FAQ</h5>

                                    
                                </div>

                                {faq.map(
                                    (item, index) => (
                                        <div
                                            key={index}
                                            className="border p-3 mb-3"
                                        >
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder="Question"
                                                value={
                                                    item.question
                                                }
                                                onChange={e =>
                                                    handleFaqChange(
                                                        index,
                                                        'question',
                                                        e.target
                                                            .value
                                                    )
                                                }
                                            />

                                            <textarea
                                                rows={3}
                                                className="form-control mb-2"
                                                placeholder="Answer"
                                                value={
                                                    item.answer
                                                }
                                                onChange={e =>
                                                    handleFaqChange(
                                                        index,
                                                        'answer',
                                                        e.target
                                                            .value
                                                    )
                                                }
                                            />

                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() =>
                                                    removeFaq(
                                                        index
                                                    )
                                                }
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    )
                                )}
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={addFaq}
                                    >
                                        Add FAQ
                                    </button>
                                </div>
                            </div>

                            <div className="text-end">

                                <button
                                    type="submit"
                                    className="btn shadow-none"
                                    disabled={isLoading || uploadingCount > 0}
                                >
                                    {uploadingCount > 0
                                        ? "Uploading Images..."
                                        : isLoading
                                        ? "Creating..."
                                        : "Create"}
                                </button>

                                {/*<button
                                    type="submit"
                                    className="btn shadow-none"
                                    disabled={
                                        isLoading
                                    }
                                >
                                    {isLoading
                                        ? 'Creating...'
                                        : 'Create'}
                                </button> */}

                            </div>

                        </form>

                    </div>

                </div>

            </div>
        </div>
    )
}

export default Create
